
if (typeof ToggleTab !== 'function') {

  class ToggleTab extends HTMLElement {

    constructor() {
      super();

      this._prefix = window.KT_PREFIX || '';
      this.titleEl = this.querySelector('[data-js-title]');
      this.contentEl = this.querySelector('[data-js-content]');

      this._animationTimer = null;
      this._sliderTimer = null;

      this.titleEl.innerHTML = `${this.titleEl.innerHTML}${
        this.hasAttribute('data-togglepack-alternate')
          ? KROWN.settings.symbols.toggle_pack_alternate
          : KROWN.settings.symbols.toggle_pack
      }`;

      this.toggleInert = true;

      this.syncInitialState();

      this.titleEl.addEventListener(
        'click',
        this.onClickHandler.bind(this)
      );

      this.titleEl.addEventListener('keydown', e => {
        const isEnter = e.key === 'Enter';
        const isSpace = e.key === ' ' || e.key === 'Spacebar';

        if (!isEnter && !isSpace) {
          return;
        }

        if (this.titleEl.matches('button, a[href]')) {
          return;
        }

        e.preventDefault();
        this.titleEl.click();
      });
    }

    isOpened() {
      return this.classList.contains(`${this._prefix}opened`);
    }

    syncInitialState() {
      const opened = this.isOpened();

      this.titleEl.setAttribute(
        'aria-expanded',
        String(opened)
      );

      if (opened) {
        this.contentEl.removeAttribute('inert');
      } else {
        this.contentEl.setAttribute('inert', '');
      }
    }

    clearAnimation() {
      if (this._animationTimer !== null) {
        clearTimeout(this._animationTimer);
        this._animationTimer = null;
      }


      this.contentEl.style.removeProperty('height');
      this.contentEl.style.removeProperty('padding-top');
      this.contentEl.style.removeProperty('padding-bottom');
      this.contentEl.style.removeProperty('margin-top');
      this.contentEl.style.removeProperty('margin-bottom');
      this.contentEl.style.removeProperty('overflow');
      this.contentEl.style.removeProperty('transition-duration');
      this.contentEl.style.removeProperty('transition-property');
    }

    onClickHandler() {
      if (this._sliderTimer !== null) {
      clearTimeout(this._sliderTimer);
      this._sliderTimer = null;
    }
      if (!this.isOpened()) {

        this.classList.add(`${this._prefix}opened`);
        this.titleEl.setAttribute('aria-expanded', 'true');
        this.contentEl.removeAttribute('inert');

        this.slideDown(this.contentEl, 200);

        this._sliderTimer = setTimeout(() => {
          if (this.isOpened()) {
            this.contentEl.querySelector('css-slider')?.resetSlider();
          }
          this._sliderTimer = null;
        }, 200);

      } else {

        // Keep focus on the trigger if it is inside closing content.
        const activeElement = document.activeElement;

        if (
          activeElement &&
          this.contentEl.contains(activeElement)
        ) {
          this.titleEl.focus();
        }

        this.classList.remove(`${this._prefix}opened`);
        this.titleEl.setAttribute('aria-expanded', 'false');

        // Prevent keyboard focus from entering closing content.
        this.contentEl.setAttribute('inert', '');

        this.slideUp(this.contentEl, 200);
      }
    }

    slideUp(target, duration) {
      this.clearAnimation();

      // Ensure the element is measurable before collapsing.
      target.style.removeProperty('display');

      const currentHeight = target.offsetHeight;

      target.style.transitionProperty = 'height, margin, padding';
      target.style.transitionDuration = duration + 'ms';
      target.style.boxSizing = 'border-box';
      target.style.height = currentHeight + 'px';

      target.offsetHeight;

      target.style.overflow = 'hidden';
      target.style.height = '0px';
      target.style.paddingTop = '0px';
      target.style.paddingBottom = '0px';
      target.style.marginTop = '0px';
      target.style.marginBottom = '0px';

      this._animationTimer = setTimeout(() => {
        this._animationTimer = null;

        // Never let an old close operation hide reopened content.
        if (!this.isOpened()) {
          target.style.display = 'none';
          this.clearAnimation();
        }
      }, duration);
    }

    slideDown(target, duration) {
      this.clearAnimation();

      target.style.removeProperty('display');

      let display = window.getComputedStyle(target).display;

      if (display === 'none') {
        display = 'block';
      }

      target.style.display = display;

      const height = target.offsetHeight;

      target.style.overflow = 'hidden';
      target.style.height = '0px';
      target.style.paddingTop = '0px';
      target.style.paddingBottom = '0px';
      target.style.marginTop = '0px';
      target.style.marginBottom = '0px';

      target.offsetHeight;

      target.style.boxSizing = 'border-box';
      target.style.transitionProperty = 'height, margin, padding';
      target.style.transitionDuration = duration + 'ms';
      target.style.height = height + 'px';

      target.style.removeProperty('padding-top');
      target.style.removeProperty('padding-bottom');
      target.style.removeProperty('margin-top');
      target.style.removeProperty('margin-bottom');

      this._animationTimer = setTimeout(() => {
        this._animationTimer = null;

        if (this.isOpened()) {
          this.clearAnimation();
        }
      }, duration);
    }
  }

  if (typeof customElements.get('toggle-tab') == 'undefined') {
    customElements.define('toggle-tab', ToggleTab);
  }
}

if (typeof ToggleGroup !== 'function') {

  class ToggleGroup extends HTMLElement {

    constructor() {
      super();

      this._prefix = window.KT_PREFIX || '';

      this.querySelectorAll('toggle-tab').forEach(allToggle => {
        allToggle.querySelector('[data-js-title]')
          .addEventListener('click', () => {

            this.querySelectorAll(
              `toggle-tab.${this._prefix}opened`
            ).forEach(openedToggle => {

              if (allToggle !== openedToggle) {
                openedToggle.onClickHandler();
              }
            });
          });
      });
    }
  }

  if (typeof customElements.get('toggle-group') == 'undefined') {
    customElements.define('toggle-group', ToggleGroup);
  }
}
